export enum PreferencesTab {
  Accounts,
  Integrations,
  Copilot,
  Git,
  Appearance,
  Notifications,
  Prompts,
  Advanced,
  Accessibility,
}
